module.exports = __webpack_public_path__ + "static/media/Spinner.93abc97c.gif";